import {IconProps} from "../../types/IconProps";

export const ActivateAllIcon = ({ width = 800, color = '#000'}: IconProps) => {
    return (
        <svg width={`${width}px`} height={`${width}px`} viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 16L16.1 18.5L20 13.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10 14H3" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M10 18H3" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M3 6L13.5 6M20 6L17.75 6" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M20 10L9.5 10M3 10H5.25" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    )
}